import {
  Card as MantineCard,
  CardProps as MantineCardProps,
  PolymorphicComponentProps,
} from "@mantine/core";
import React, { ReactNode } from "react";

export interface ExtendedCardProps extends MantineCardProps {
  justify?:
    | "center"
    | "flex-start"
    | "flex-end"
    | "space-between"
    | "space-around"
    | "space-evenly";
  backgroundImage?: ReactNode;
}

export type CardProps<C = "div"> = PolymorphicComponentProps<
  C,
  ExtendedCardProps
>;

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ justify, style, backgroundImage, ...props }, ref) => {
    return (
      <MantineCard
        ref={ref}
        {...props}
        style={{
          ...(justify && {
            display: "flex",
            justifyContent: justify,
          }),
          ...(backgroundImage && { position: "relative" }),
          ...style,
        }}
      >
        {backgroundImage && (
          <MantineCard
            w="100%"
            h="100%"
            pos="absolute"
            top={0}
            left={0}
            p={0}
            bg={props.bg || "layoutDark"}
            style={{
              zIndex: 0,
              overflow: "hidden",
            }}
          >
            {backgroundImage}
          </MantineCard>
        )}
        <div
          style={{
            position: "relative",
            zIndex: 1,
            width: "100%",
            height: justify ? "auto" : "100%",
            margin: "auto",
          }}
        >
          {props.children}
        </div>
      </MantineCard>
    );
  }
) as <C = "div">(props: CardProps<C>) => React.ReactElement;
